import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import RgLimitsBar from "@sazka/ng/rg-limits/rg-limits-bar.vue";
import { usePopupsSequence } from "@/shared/components/master-page/use-popups-sequence";


export default /*@__PURE__*/_defineComponent({
  __name: 'rg-limits-bar-wrapper',
  setup(__props) {

const { isRgLimitsBarVisible, isRgLimitsBarClosed, isLegalWarningVisible } = usePopupsSequence();

const closeRgLimitsBarHandler = () => {
    isRgLimitsBarClosed.value = true;
};

const openRgLimitsBarHandler = () => {
    isRgLimitsBarVisible.value = !isLegalWarningVisible.value;
};

return (_ctx: any,_cache: any) => {
  return (_unref(isRgLimitsBarVisible))
    ? (_openBlock(), _createBlock(RgLimitsBar, {
        key: 0,
        onCloseRgLimitsBar: closeRgLimitsBarHandler,
        onOpenRgLimitsBar: openRgLimitsBarHandler
      }))
    : _createCommentVNode("", true)
}
}

})